var map = {
	"./allow.svg": "b470",
	"./arrow-right.svg": "20d7",
	"./checkmark.svg": "ccd9",
	"./coin.svg": "222b",
	"./coin1.svg": "6c5e",
	"./deny.svg": "1acc",
	"./info-circle.svg": "0dcb",
	"./left-arrow.svg": "3906",
	"./notFound.svg": "934d",
	"./people.svg": "ac6f",
	"./roblox-input.svg": "cd06",
	"./rub.svg": "f055",
	"./wait.svg": "c31d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e2d8";